import React from 'react'
import PropTypes from 'prop-types'
import AccessedItemImage from './AccessedItemImage'
import './AccessedItemTile.scss'

const AccessedItemTile = props => {
  let productAuthors
  if (props.item.type === 'playlist') {
    productAuthors = (
      <a href={`users/${props.item.authors.slug}`}>{props.item.authors.name}</a>
    )
  } else {
    productAuthors = props.item.authors.map((coach, idx) => {
      let coachName = `${coach.firstName} ${coach.lastName}`
      if (
        props.item.authors.length > 1 &&
        idx === props.item.authors.length - 1
      ) {
        coachName = ' & '.concat(coachName)
      }
      if (
        props.item.authors.length > 0 &&
        idx < props.item.authors.length - 2
      ) {
        coachName += ', '
      }
      return (
        <span key={idx}>
          <a href={coach.slug ? '/instructors/' + coach.slug : '#'}>
            {coachName}
          </a>
        </span>
      )
    })
  }

  return (
    <div className='AccessedItemTile'>
      <AccessedItemImage item={props.item} />
      <div className='AccessedItemTile__description'>
        <div className='AccessedItemTile__title'>
          <a href={props.item.link}>{props.item.title}</a>
        </div>
        <div className='AccessedItemTile__author'>
          <span className='AccessedItemTile__type'>{props.item.type}</span> by{' '}
          <span className='AccessedItemRow__authorName'>{productAuthors}</span>
        </div>
      </div>
    </div>
  )
}

AccessedItemTile.propTypes = {
  item: PropTypes.object
}

export default AccessedItemTile
